import Box from '@material-ui/core/Box';
import * as React from 'react';
export default {
  Box,
  React
};